<template>
    <div class="amazon-pay" @click.capture="() => {}">
        <template v-if="clientIdSet">
            <script
                v-if="isLive"
                type="application/javascript"
                async="async"
                src="https://static-eu.payments-amazon.com/OffAmazonPayments/eur/lpa/js/Widgets.js"
            ></script>
            <script
                v-else
                type="application/javascript"
                async="async"
                src="https://static-eu.payments-amazon.com/OffAmazonPayments/eur/sandbox/lpa/js/Widgets.js"
            ></script>
        </template>

        <div v-if="!orderReferenceId" class="amazonpay-login">
            <div class="login-text">
                {{ $t('Checkout.payment.amazonPay.login') }}
            </div>

            <button type="button" class="btn p-0" ref="amazonPayButton" id="amazonPayButton"></button>
        </div>

        <div v-else class="amazonpay-wallet">
            <div class="wallet-text">
                {{ $t('Checkout.payment.amazonPay.wallet') }}
            </div>

            <div id="walletWidgetDiv"></div>

            <a class="btn btn-light mt-3" id="AmazonPayLogout" href="#" @click.prevent="logout">
                {{ $t('Generic.signOut') }}
            </a>
        </div>

        <div class="clearfix"></div>
    </div>
</template>

<script>
export default {
    name: 'AmazonPay',
    data() {
        return {
            clientId: 'amzn1.application-oa2-client.67dcaf7aee1f4aacac58da558eca37ff',
            sellerId: 'A3QLY27I7IRIT4',
            scopes: 'payments:widget',
            isLive: process.env.NODE_ENV === 'production',
            clientIdSet: false,
            accessToken: null,
            orderReferenceId: null
        };
    },
    props: {
        amazonOrderReferenceId: String
    },
    methods: {
        showAmazonPayButton() {
            OffAmazonPayments.Button('amazonPayButton', this.sellerId, {
                type: 'PwA',
                color: 'Gold', // LightGray, DarkGray
                size: 'medium',
                language: 'de-DE',

                authorization: this.authorize,

                onSignIn: this.onSignIn,

                onError: this.errorHandler
            });
        },
        authorize() {
            const loginOptions = {
                scope: this.scopes,
                popup: 'true'
            };
            let authRequest = amazon.Login.authorize(loginOptions, response => {
                //successful login
                this.accessToken = response.access_token;
            });
        },
        //Gets called after creating an orderReferenceId
        onSignIn(orderReference) {
            if (!this.orderReferenceId) {
                this.orderReferenceId = orderReference.getAmazonOrderReferenceId();
                if (!this.orderReferenceId) {
                    this.errorHandler(new Error('referenceId missing'));
                }
            }
        },
        setClientId() {
            amazon.Login.setClientId(this.clientId);
        },
        showWalletWidget() {
            new OffAmazonPayments.Widgets.Wallet({
                sellerId: this.sellerId,

                //Gets called after successful login
                onOrderReferenceCreate: orderReference => {
                    this.orderReferenceId = orderReference.getAmazonOrderReferenceId();
                },
                design: {
                    designMode: 'responsive'
                },
                //Only after payment selection the resulting orderReferenceId should be emitted
                /*onPaymentSelect: () => {
                        console.log(this);
                        this.$emit('update:amazonOrderReferenceId', this.orderReferenceId);
                    },*/
                onError: error => {
                    if (error.getErrorCode() === 'BuyerSessionExpired') {
                        this.orderReferenceId = null;
                    }
                    this.errorHandler(error);
                }
            }).bind('walletWidgetDiv');
        },
        errorHandler(error) {
            if (this.$isDev) {
                console.log(error.getErrorCode() + ': ' + error.getErrorMessage());
            }
        },
        logout() {
            this.orderReferenceId = null;
            amazon.Login.logout();
        },
        initConfirmationFlow() {
            return new Promise((resolve, reject) => {
                try {
                    OffAmazonPayments.initConfirmationFlow(this.sellerId, this.orderReferenceId, confirmationFlow => {
                        resolve(confirmationFlow);
                    });
                } catch (e) {
                    reject(e);
                }
            });
        }
    },
    watch: {
        orderReferenceId(newOrderReferenceId, prevOrderReferenceId) {
            this.$nextTick(() => {
                //every time the orderReferenceId changes the checkout amazonOrderId param gets updated
                this.$emit('update:amazonOrderReferenceId', newOrderReferenceId);

                if (!newOrderReferenceId) {
                    this.showAmazonPayButton();
                } else {
                    //initialize widget only if previous orderReference was null (login button)
                    if (!prevOrderReferenceId) {
                        this.showWalletWidget();
                    }
                }
            });
        }
    },
    mounted() {
        window.onAmazonLoginReady = this.setClientId;

        window.onAmazonPaymentsReady = () => {
            this.orderReferenceId = this.amazonOrderReferenceId;
        };

        this.clientIdSet = true;
    }
};
</script>

<style scoped lang="scss">
@use '@/styles/variables';

.amazon-pay {
    .amazonpay-login {
        #amazonPayButton {
            width: 200px;
            margin: variables.$grid-padding auto;
            display: block;
        }
    }

    .amazonpay-wallet {
        #walletWidgetDiv {
            height: 228px;
            max-height: 400px;
            margin-top: variables.$grid-padding;
        }
    }

    .clearfix {
        &::after {
            display: block;
            content: '';
            clear: both;
        }
    }
}
</style>
